<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()"></div>
      <div class="big_tit">回收记录</div>
    </div>
    <div class="content_box">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="list.length === 0 ? '' : '没有更多了'"
          @load="onLoad"
        >
          <van-empty v-if="!loading && list.length === 0" description="暂无回收记录" />
          <div class="recycle_card" v-for="item in list" :key="item.id">
            <div class="verify_code_box">
              <p class="verify_label">核销码</p>
              <p class="verify_code">{{ item.verify_code }}</p>
            </div>
            <div class="item_info">
              <img :src="item.item_img" alt="" class="item_img" />
              <div class="item_detail">
                <p class="item_title van-multi-ellipsis--l2">{{ item.item_title }}</p>
                <p class="recycle_price numberFont"><span>¥</span>{{ formatPrice(item.recycle_price) }}</p>
                <p class="item_qty">数量: {{ item.quantity }}</p>
              </div>
            </div>
            <div class="card_bottom">
              <p class="total_amount numberFont"><span>¥</span>{{ formatPrice(item.total_amount) }}</p>
              <span class="status_tag" :class="statusClass(item.status)">{{ item.status_text }}</span>
              <p class="create_time">{{ item.create_time }}</p>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { List, PullRefresh, Empty } from 'vant';

Vue.use(List).use(PullRefresh).use(Empty);

export default {
  name: "shopRecycle",
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
    };
  },
  created() {
    this.$parent.footer('user', false);
  },
  methods: {
    formatPrice(price) {
      var num = parseFloat(price) || 0;
      return num.toFixed(2);
    },
    statusClass(status) {
      if (status === 0) return 'status_pending';
      if (status === 1) return 'status_done';
      if (status === 2) return 'status_reject';
      return '';
    },
    onLoad() {
      Fetch('/shop/recycle_orders', {
        page: this.page,
        page_size: 10
      }).then((r) => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        var res = r.data;
        this.list = this.list.concat(res.list || []);
        this.loading = false;
        if ((res.list || []).length < 10) {
          this.finished = true;
        } else {
          this.page++;
        }
      }).catch(() => {
        this.loading = false;
        this.refreshing = false;
      });
    },
    onRefresh() {
      this.finished = false;
      this.page = 1;
      this.loading = true;
      this.onLoad();
    }
  },
};
</script>

<style lang="less" scoped>
.basic_wrap {
  padding-top: 44px;
  min-height: 100vh;
  background-color: #FAFAFA;
}
.content_box {
  padding: 12px 12px 0 12px;
}
.recycle_card {
  width: 100%;
  background: #FFFFFF;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 10px;
  box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
}
.verify_code_box {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  .verify_label {
    font-size: 12px;
    color: rgba(0,0,0,.6);
    margin-right: 8px;
  }
  .verify_code {
    font-size: 22px;
    font-weight: bold;
    color: #E3382E;
    letter-spacing: 2px;
  }
}
.item_info {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  .item_img {
    width: 70px;
    height: 70px;
    border-radius: 6px;
    flex-shrink: 0;
  }
  .item_detail {
    flex: 1;
    margin-left: 12px;
    .item_title {
      font-size: 13px;
      line-height: 18px;
      color: rgba(0,0,0,.8);
      height: 36px;
    }
    .recycle_price {
      font-size: 14px;
      color: #07C160;
      margin-top: 4px;
      span {
        font-size: 11px;
      }
    }
    .item_qty {
      font-size: 12px;
      color: rgba(0,0,0,.6);
      margin-top: 2px;
    }
  }
}
.card_bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  border-top: 1px solid #F0F0F0;
  .total_amount {
    font-size: 15px;
    color: #E3382E;
    font-weight: bold;
    span {
      font-size: 12px;
    }
  }
  .create_time {
    font-size: 11px;
    color: rgba(0,0,0,.4);
  }
  .status_tag {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 10px;
    &.status_pending {
      background: rgba(255, 153, 0, 0.1);
      color: #FF9900;
      border: 1px solid #FF9900;
    }
    &.status_done {
      background: rgba(7, 193, 96, 0.1);
      color: #07C160;
      border: 1px solid #07C160;
    }
    &.status_reject {
      background: rgba(238, 10, 10, 0.1);
      color: #EE0A0A;
      border: 1px solid #EE0A0A;
    }
  }
}
</style>
